import { FormRules } from "../BaseComponents/Form/type";
const t = {
  required: "This field is required",
  email: "Enter a valid email address",
};
export const fieldIsRequired: FormRules = [
  { required: true, message: t.required },
];
export const emailValidation: FormRules = [
  {
    type: "email",
    message: t.email,
  },
];
